const phoneRegExp = new RegExp(/^(0|[1-9][0-9]{9})$/i);
const NonDigitRegExp = new RegExp(/[^\d]/g);

export const validatePhone = (value?: string) => {
  return value && !phoneRegExp.test(value.replace(NonDigitRegExp, ''))
    ? 'Invalid phone number, must be 10 digits'
    : undefined;
};
